import styled from 'styled-components'

export const Table = styled.div`
  border-radius: 1rem;
  background: linear-gradient(203deg, #f5f7ff 3.24%, #edfcf7 96.1%);
  padding: 6rem;

  @media (max-width: 999px) {
    padding: 4rem;
  }

  @media (max-width: 767px) {
    overflow-x: auto;
    scrollbar-width: none;
    margin-right: -1.5rem;
    border-radius: 1rem 0 0 1rem;
  }
`

export const Item = styled.div`
  padding: 1rem 0;
  display: grid;
  grid-template-columns: 20rem 70rem;
  align-items: flex-start;
  gap: 4rem;
  &:not(:last-child) {
    border-bottom: 2px solid #fff;
  }

  @media (max-width: 1279px) {
    grid-template-columns: 20rem 1fr;
  }

  @media (max-width: 767px) {
    grid-template-columns: 17.5rem 36rem;
    width: 56.2rem;
    gap: 2rem;
  }
`

export const Label = styled.div`
  font-family: Navigo, Arial, Helvetica, sans-serif;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #292e3d;
  font-weight: 500;
`

export const Text = styled.div`
  font-family: Navigo, Arial, Helvetica, sans-serif;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #292e3d;
  font-weight: 400;

  ul {
    margin-top: 2rem;
  }

  li {
    padding-left: 2.5rem;
    position: relative;

    &:not(:last-child) {
      margin-bottom: 1.5rem;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 1.1rem;
      left: 1rem;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #292e3d;
    }
  }
`
